function initializeSlider() {
  const sliders = document.querySelectorAll("[data-slider]");

  sliders.forEach((slider) => {
    const sliderContainer = slider.querySelector(".slider-container");
    const indicatorProgress = slider.querySelector(".indicator-progress");
    const cardsVisibleDesktop =
      parseFloat(slider.dataset.cardsVisibleDesktop) || 4;
    const cardsVisibleMobile =
      parseFloat(slider.dataset.cardsVisibleMobile) || 1.5;
    const totalCards =
      parseInt(slider.dataset.totalCards, 10) ||
      sliderContainer.children.length;
    const cardsGap = parseFloat(slider.dataset.cardsGap) || 4;

    let cardsVisible = cardsVisibleDesktop;
    let viewportWidth = window.innerWidth; // Use the actual viewport width for device size detection
    let parentWidth = slider.offsetWidth; // Use slider width for container calculations
    let isMobile = viewportWidth <= 749;
    let currentTranslate = 0;
    let previousTranslate = 0;
    let currentIndex = 0;
    let autoSlideInterval;
    let isDragging = false;
    let hasDragged = false;
    let startX;

    if (!sliderContainer || !indicatorProgress) return;

    // Update cardsVisible and parent width based on viewport width
    function updateCardsVisible() {
      viewportWidth = window.innerWidth; // Update to the actual viewport width
      parentWidth = slider.offsetWidth; // Update slider container width
      isMobile = viewportWidth <= 749; // Check for mobile based on viewport width
      cardsVisible = isMobile ? cardsVisibleMobile : cardsVisibleDesktop;
    }

    // Set dynamic width of the slider container
    function setSliderWidth() {
      const cardWidth =
        (parentWidth - cardsGap * (cardsVisible - 1)) / cardsVisible; // Calculate card width based on cardsVisible
      // Set card widths dynamically
      Array.from(sliderContainer.children).forEach((child) => {
        child.style.flex = `0 0 ${cardWidth}px`;
        child.style.maxWidth = `${cardWidth}px`;
      });

      // Set total width of the slider container
      sliderContainer.style.width = `${cardWidth * totalCards + cardsGap * (totalCards - 1)
        }px`;
    }

    // Update the slider position based on the current index
    function setPositionByIndex() {
      const cardWidth = sliderContainer.children[0].offsetWidth + cardsGap;
      const totalWidth = cardWidth * totalCards - cardsGap; // Total width minus the last gap
      const maxTranslate = totalWidth - parentWidth; // Max translateX value
      const maxIndex = Math.ceil(totalCards - cardsVisible); // Fix max index calculation

      // Clamp the current index to stay within valid bounds
      currentIndex = Math.min(Math.max(currentIndex, 0), maxIndex);

      // Calculate the new translate value
      currentTranslate = currentIndex * -cardWidth;

      // Ensure no blank space appears on the last slide
      if (totalWidth - Math.abs(currentTranslate) < parentWidth) {
        currentTranslate = -maxTranslate;
      }

      // Apply transformation
      sliderContainer.style.transition = "transform 0.5s ease-in-out";
      sliderContainer.style.transform = `translateX(${currentTranslate}px)`;

      updateIndicator();
    }

    // Update progress indicator
    function updateIndicator() {
      const maxIndex = Math.ceil(totalCards - cardsVisible);
      const totalSteps = maxIndex + 1; // Number of valid slides
      const stepWidth = 100 / totalSteps; // Ensure equal step size for each slide

      // Ensure the indicator doesn't exceed the view
      indicatorProgress.style.width = `${stepWidth}%`;
      indicatorProgress.style.left = `${currentIndex * stepWidth}%`;
    }

    // Handle window resize
    function handleResize() {
      updateCardsVisible();
      setSliderWidth();
      setPositionByIndex();
      currentIndex = 0; // Reset to the first slide on resize
    }

    const resizeObserver = new ResizeObserver(() => {
      handleResize();
    });

    resizeObserver.observe(document.body);

    // Automatically move to the next slide
    function showNextSlide() {
      const maxIndex = Math.ceil(totalCards - cardsVisible);

      if (currentIndex < maxIndex) {
        currentIndex++;
      } else {
        currentIndex = 0; // Loop back to the first slide
      }

      setPositionByIndex();
      previousTranslate = currentTranslate;
    }

    // Start auto-sliding
    function startAutoSlide() {
      stopAutoSlide();
      autoSlideInterval = setInterval(showNextSlide, 3000);
    }

    // Stop auto-sliding
    function stopAutoSlide() {
      clearInterval(autoSlideInterval);
    }

    // Drag start
    function startDrag(e) {
      isDragging = true;
      hasDragged = false;
      startX = e.pageX || e.touches[0].clientX;
      sliderContainer.style.transition = "none";
      stopAutoSlide();
    }

    // Dragging
    function drag(e) {
      if (!isDragging) return;
      const currentPosition = e.pageX || e.touches[0].clientX;
      const distanceMoved = currentPosition - startX;

      currentTranslate = previousTranslate + distanceMoved;
      sliderContainer.style.transform = `translateX(${currentTranslate}px)`;

      if (Math.abs(distanceMoved) > 10) {
        hasDragged = true;
      }
    }

    // End drag
    function endDrag() {
      if (isDragging) {
        isDragging = false;

        if (hasDragged) {
          const cardWidth = sliderContainer.children[0].offsetWidth;
          const dragDistance = currentTranslate - previousTranslate;

          const slidesDragged = Math.round(dragDistance / cardWidth);

          currentIndex = Math.min(
            Math.max(currentIndex - slidesDragged, 0),
            Math.ceil(totalCards - cardsVisible)
          );

          setPositionByIndex();
        }

        previousTranslate = currentTranslate;
        // startAutoSlide();
      }
    }

    // Prevent accidental navigation on drag
    sliderContainer.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", function (e) {
        if (hasDragged) {
          e.preventDefault();
        }
        hasDragged = false;
      });
    });

    // Initialize the slider
    setTimeout(() => {
      updateCardsVisible();
      setSliderWidth();
      setPositionByIndex();
      // startAutoSlide();
    }, 50);

    // Attach drag and touch listeners
    sliderContainer.addEventListener("mousedown", startDrag);
    sliderContainer.addEventListener("touchstart", startDrag);
    sliderContainer.addEventListener("mousemove", drag);
    sliderContainer.addEventListener("touchmove", drag);
    sliderContainer.addEventListener("mouseup", endDrag);
    sliderContainer.addEventListener("mouseleave", endDrag);
    sliderContainer.addEventListener("touchend", endDrag);

    // Mouse wheel / trackpad scrolling
    let wheelTimeout = null;

    slider.addEventListener(
      "wheel",
      (e) => {
        if (Math.abs(e.deltaX) > 0) e.preventDefault();

        const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
        if (!isHorizontal) return;

        const direction = e.deltaX;

        // Ignore tiny movements
        if (Math.abs(direction) < 5) return;

        // Prevent overscrolling
        if (wheelTimeout) return;

        wheelTimeout = setTimeout(() => {
          wheelTimeout = null;
        }, 350);

        const maxIndex = Math.ceil(totalCards - cardsVisible);

        // Next slide
        if (direction > 0) {
          currentIndex = Math.min(currentIndex + 1, maxIndex);
        }
        // Previous slide
        else {
          currentIndex = Math.max(currentIndex - 1, 0);
        }

        setPositionByIndex();
        previousTranslate = currentTranslate;
      },
      { passive: false }
    );

  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeSlider);
} else {
  initializeSlider(); // Run immediately if DOM is already loaded
}